import './login.css';

import React, { useEffect, useState } from 'react';
import {
  Link,
  useSearchParams
} from 'react-router-dom';

import SocialLogin from './SocialLogin';


export const Login = () => {

  const [searchParams] = useSearchParams();

  const [errorMessage, setErrorMessage] = useState('');


  /* ============================================
     REDIRECT DUPA LOGIN
  ============================================ */

  const redirect = searchParams.get('redirect') || '/functionalpagelogin';


  /* ============================================
     LOGIN ERROR
  ============================================ */

  useEffect(() => {

    const error = searchParams.get('error');

    if (error) {
      setErrorMessage(
        decodeURIComponent(error)
      );
    }

  }, [searchParams]);


  return (

    <div className="container-login">

      <div className="login-card-wrapper">


        {/* ERROR */}

        {errorMessage && (

          <div className="error-message-google">

            <span className="error-icon">
              ⚠️
            </span>

            <p>
              {errorMessage}
            </p>

          </div>

        )}



        {/* LOGIN OPTIONS */}

        <div>

          <SocialLogin
            allowDirectSignup
            redirectAfterLogin={redirect}
          />

        </div>



        {/* REGISTER */}

        <div className="redirect-registrer">

          <b className="redirect-reg-text">
            Nou pe Contalearn?
          </b>

          <Link
            to={`/quiz-start?redirect=${encodeURIComponent(redirect)}`}
            className="redirect-reg-link"
          >
            <b className="redirect-reg-link">
              Creeaza-ti un cont
            </b>
          </Link>

        </div>


      </div>

    </div>

  );

};